import { render, staticRenderFns } from "./DescriptionModal.vue?vue&type=template&id=32cb9730&scoped=true&"
import script from "./DescriptionModal.vue?vue&type=script&lang=js&"
export * from "./DescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionModal.vue?vue&type=style&index=0&id=32cb9730&lang=scss&scoped=true&"
import style1 from "./DescriptionModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb9730",
  null
  
)

export default component.exports